import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import { formatPriceValue } from '@propertypal/shared/src/utils/search/inputFormating';
import SelectInput, { Option } from '@propertypal/web-ui/src/inputs/SelectInput';
import React, { FunctionComponent } from 'react';

interface Props {
  filters: SearchState['filters'];
  minPriceOptions: Option[];
  maxPriceOptions: Option[];
  handleFilterChange: UseSearchState['handleFilterChange'];
  currencySymbol: string;
}

const PriceInputs: FunctionComponent<Props> = ({
  filters,
  minPriceOptions,
  maxPriceOptions,
  handleFilterChange,
  currencySymbol,
}) => {
  return (
    <>
      <SelectInput
        ariaLabel="Choose minimum price"
        containerStyle={{ marginRight: 15 }}
        id="selectMinPrice"
        label="Price Range"
        onChange={handleFilterChange('minPrice')}
        options={minPriceOptions}
        placeholder="Minimum Price"
        value={filters.minPrice}
        testID="selectMinPrice"
        wildcard={formatPriceValue('min', currencySymbol)}
      />

      <SelectInput
        ariaLabel="Choose maximum price"
        id="selectMaxPrice"
        label="&nbsp;"
        onChange={handleFilterChange('maxPrice')}
        options={maxPriceOptions}
        placeholder="Maximum Price"
        value={filters.maxPrice}
        testID="selectMaxPrice"
        wildcard={formatPriceValue('max', currencySymbol)}
      />
    </>
  );
};

export default PriceInputs;
